import { useMemo } from 'react'
import isArray from 'lodash/isArray'

import { ENTITY_COMMAND_TYPE } from '@types'

export const useCommandTypeOptions = (commandTypes?: ENTITY_COMMAND_TYPE[]) => {
  const values = isArray(commandTypes) ? commandTypes : Object.values(ENTITY_COMMAND_TYPE)

  return useMemo(() => values?.map(type => ({ id: type, label: type })) ?? [], [])
}
